export const defaultModes = ['gitlab', 'github']
export const defaultIdPrefix = 'site-mode-'
